import type {CallMode} from '@pexip/infinity';

/**
 * Parses an untrusted value, such as a branding setting, into a `CallMode`.
 *
 * @example
 * parseCallMode('switching'); // 'switching'
 * parseCallMode('mcu'); // undefined
 */
export const parseCallMode = (value: unknown): CallMode | undefined =>
    value === 'WEBRTC' || value === 'switching' ? value : undefined;
